import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchCampaignLog } from '../../../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import ViewCampaign from '../../../components/logging/campaigns/ViewCampaign';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  logs: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
};

class CampaignViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchCampaignLog(this.props.params.id));
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="option component" style={authPage}>
        <ViewCampaign
          log={this.props.logs.log}
        />
      </div>
    );
  }
}

CampaignViewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

CampaignViewPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    logs: state.options,
  };
}

export default withRouter(connect(mapStateToProps)(CampaignViewPage));



// WEBPACK FOOTER //
// ./src/containers/logging/campaigns/CampaignViewPage.js